// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__PAqJq","author":"Table_author__2MoEd","authorImage":"Table_authorImage__fX-1U","unreadRow":"Table_unreadRow__173VV"};